<div class="filters-mobile-header">
  <app-button-transparent [text]="cancelBtnText" size="medium" (clicked)="onCancel()"> </app-button-transparent>
  {{ title }}
  <app-button-transparent *ngIf="useClear" [text]="clearBtnText" size="medium" [disabled]="clearDisabled" (clicked)="onClear()">
  </app-button-transparent>
</div>
